export const recommendedReplyList = [
  {
    roleId: 2969,
    list: [
      '"Guess you\'ll have to stick around and find out for yourself."',
      '*I try to play it cool, but her stare is intense.* "Uh... hoping to be cool. Just trying to survive Rush Week."',
      "\"Depends on your definition of 'cool.' What's your story?\"",
      '*I smirk, looking her up and down just like she did to me.* "Let\'s just say I have potential. The real question is, can you handle it?"',
      "\"Let's go with 'actually cool.' Why? You looking for someone interesting?\""
    ]
  },
  {
    roleId: 3137,
    list: [
      '"Guess you\'ll have to stick around and find out for yourself."',
      '*I try to play it cool, but her stare is intense.* "Uh... hoping to be cool. Just trying to survive Rush Week."',
      "\"Depends on your definition of 'cool.' What's your story?\"",
      '*I smirk, looking her up and down just like she did to me.* "Let\'s just say I have potential. The real question is, can you handle it?"',
      "\"Let's go with 'actually cool.' Why? You looking for someone interesting?\""
    ]
  },
  {
    roleId: 3212,
    list: [
      '"Yeah, no problem. I\'m hiding out too. The bass was making my figures rattle on the shelf. Make yourself at home."',
      '*You just nod towards the empty space on your bed, pulling your headphones down around your neck.* "Go for it. It\'s a warzone out there."',
      '"Another refugee from the \'greatest night ever\' brigade, huh? Be my guest. Just, uh... try not to trip over the mess."',
      '"Sure. As long as you\'re quiet. Close the door all the way, you can still hear the shitty music."',
      '*You\'re startled, quickly alt-tabbing out of whatever was on your screen.* "Oh—uh, yeah, of course. Take a seat. I get it, parties suck."'
    ]
  },
  {
    roleId: 3402,
    list: [
      '*I take another slow bite of my sandwich, completely unfazed.* "You\'re really, *really* bad at this seduction thing. Calling me a pig isn\'t exactly prime foreplay, Vania."',
      "*I sigh and put the rest of my sandwich away.* \"Okay, fine. But let's set a ground rule: no more 'moid' or 'pig' talk while you're... you know. Eating.\"",
      '"So let me get this straight. You hate me, you hate what I stand for, but you want to suck my dick because you\'re hungry. Is that the gist of it?"',
      "*I raise an eyebrow, chewing thoughtfully.* \"You know, you could have just asked. You didn't need the whole 'ooh my boobies' routine. It was kinda sad.\"",
      '*I finish my sandwich and wipe my mouth.* "So, is this gonna be a regular thing? Because if so, you need to work on your sales pitch. It\'s terrible."'
    ]
  },
  {
    roleId: 3681,
    list: [
      '"Hey, it\'s alright, don\'t worry about it. Are you okay?"',
      '"Whoa, careful. It\'s no big deal. Let me help you with that."',
      "\"Oh, man... I'm sorry. Look, I'll buy you a new sandwich, it's the least I can do.\"",
      '"Don\'t apologize, it was just an accident. You sound really hungry, though."',
      '"It\'s fine, really. Please don\'t cry. We can get you another sandwich."'
    ]
  },
  {
    roleId: 3148,
    list: [
      "I'll do my best not to slow you down.",
      'Someone has to carry your stuff.',
      "Don't worry, I won't get in your way.",
      "You'd be surprised what I can handle.",
      'Just tell me where to stand and what not to touch.'
    ]
  },
  {
    roleId: 3184,
    list: [
      'I want to be a crafty rogue. What do you recommend?',
      "What's a good race for a magic user?",
      'Recommend me something strong, a good fighter.',
      'Which race has the highest fertility?',
      "Just show me the base races, I'll pick one myself."
    ]
  },
  {
    roleId: 3512,
    list: [
      '"Anything?" *A smirk plays on my lips as I stop my swing, resting the bat on my shoulder and looking you up and down.* "That\'s a very dangerous word to use with me, Akane."',
      '"A personal cheerleader, huh? And what exactly does that entail? I\'m going to need you to be very specific about the... services you\'re offering."',
      "\"You know, I've always thought that uniform was a little too tight on you. Why don't you show me what's underneath? A little preview for your new team captain.\"",
      "\"Get on your knees. If you really want to do 'whatever' I want, you can start by showing me how you'll be cheering for me from now on.\"",
      "\"Forget Noharu. He's a lost cause. This isn't about him anymore. This is about you, me, and what you're willing to do to be mine.\""
    ]
  },
  {
    roleId: 3728,
    list: [
      "I-I'm sorry to intrude... I'm lost. The snow is getting worse. I saw the light from your fire and just hoped for a moment's shelter. Please, I mean you no harm.",
      "*I hold up my hands to show I'm unarmed, my body shivering uncontrollably from the biting cold.* Forgive me, I am just a traveler. The blizzard... it's too strong. I will leave as soon as it passes, I swear it.",
      "*I stumble forward and fall to my knees in the snow, exhausted and weak.* Please... help me. I was attacked... by bandits... I'm hurt. I have nowhere else to go.",
      '*My eyes widen at the sight of you, a mix of fear and awe on my face. I immediately drop into a low bow, my head touching the snow.* Great spirit of the mountain, forgive my trespass! I am a humble wanderer who has lost his way. I beg your mercy.',
      "*I don't flinch at the knife, though my gaze is wary. I slowly shrug off the pack from my shoulders, opening it to reveal dried fish and a small bundle of herbs.* An offering. For shelter from the storm. That is my business."
    ]
  },
  {
    roleId: 3330,
    list: [
      '"Oh, thank you, Eto-san. Please don\'t worry about the mess. I hope Satomi feels better soon. I\'ll just wait here."',
      '"Uh, yeah. Thanks. Tea sounds... good." *I follow you inside, trying not to stare as I find a place to sit, my eyes darting around the cluttered but cozy living room.*',
      '"Okay, thank you. I don\'t mind waiting." *I step inside, closing the door quietly behind me and taking a seat on the edge of the sofa, simply observing the small, lived-in space.*',
      '"Thanks for letting me in. Actually, can I help with the tea? It\'s no trouble, really. You look like you just woke up."',
      '"Heh, a little mess never hurt anyone. Thanks." *I follow you in, my gaze lingering on your figure for a moment before I lean against the doorframe.* "Sure, I\'ll wait. Don\'t rush on my account."'
    ]
  },
  {
    roleId: 3210,
    list: [
      '"Hey, you dropped this." *I bend down, picking up the pack and holding it out to you, my voice soft.* "You alright? It\'s a lot in there."',
      '"Just getting some air." *I nudge the pack with the toe of my boot.* "You dropped that."',
      '*A slow smile spreads across my face as I pick up the pack, dangling it from my fingers.* "Only if you\'re offering one. And maybe your name to go with it?"',
      '"Nothing. Just escaping, same as you probably." *I gesture with my head back towards the thumping bass.* "Place is a fucking sweatbox."',
      '"Just your cigarettes." *I crouch to pick them up, placing the pack on the step next to your hand before sitting a few feet away.* "Mind if I join you out here?"'
    ]
  }
]
